<template>
<div class="comment-star-rating" style="display: inline-block;">
  <span
    v-for="star in 5"
    :key="star"
    class="comment-star"
    :class="{ 'comment-star-filled': star <= rating }"
    style="font-size: 1.2em; margin-right: 2px;"
  >
    ★
  </span>
</div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.comment-star {
  color: #ccc;
}

.comment-star-filled {
  color: #fddf00; /* gold */
}
</style>
